/* ============================================================
   Pholoh cart rewards bar — TEES "Buy 2, get 1 free". Counts the T-shirts in the
   cart: 1 shirt = halfway, 2 shirts = free shirt unlocked. Recomputes on every
   cart change (ajaxProduct:added + [data-subtotal] mutation) via /cart.js. Also
   mirrors the live total onto the checkout button + drawer title count.
   ============================================================ */
(function () {
  'use strict';

  // A cart line is a "shirt" if its handle/type/title says so (tees are '*-t-shirt').
  function isShirt(it) {
    var h = (it.handle || '').toLowerCase();
    var t = (it.product_type || '').toLowerCase();
    var ti = (it.product_title || it.title || '').toLowerCase();
    return h.indexOf('t-shirt') > -1 || t.indexOf('shirt') > -1 || t.indexOf('tee') > -1 || ti.indexOf('t-shirt') > -1;
  }
  function countShirts(cart) {
    var n = 0;
    (cart.items || []).forEach(function (it) { if (isShirt(it)) n += (it.quantity || 0); });
    return n;
  }

  function render(bar, shirts) {
    // Repeating "buy 2, get 1 free": progress cycles every 2 tees, then resets.
    var cyclePos = shirts % 2;
    var freeCount = Math.floor(shirts / 2);
    var seg1 = 0, seg2 = 0, completeNow = false;
    if (shirts > 0 && cyclePos === 0) { seg1 = 100; seg2 = 100; completeNow = true; }
    else if (cyclePos === 1) { seg1 = 100; }
    var fills = bar.querySelectorAll('.rewards__seg-fill');
    if (fills[0]) fills[0].style.width = seg1 + '%';
    if (fills[1]) fills[1].style.width = seg2 + '%';
    var tiers = bar.querySelectorAll('.rewards__tier');
    if (tiers[0]) tiers[0].classList.toggle('is-done', seg1 >= 100);
    if (tiers[1]) tiers[1].classList.toggle('is-done', seg2 >= 100);
    var msg = bar.querySelector('[data-gwp-msg]');
    if (msg) {
      if (shirts <= 0) msg.innerHTML = 'Add 2 tees, get 1 <strong>free</strong>';
      else if (cyclePos === 1) msg.innerHTML = 'Add <strong>1 more tee</strong> — get 1 free';
      else {
        var earned = freeCount === 1 ? 'Free tee unlocked!' : freeCount + ' free tees unlocked!';
        msg.innerHTML = earned + ' Add <strong>2 more</strong> for another';
      }
    }
    bar.classList.toggle('rewards--complete', completeNow);
  }

  function renderAll(shirts) {
    document.querySelectorAll('[data-pholoh-gwp]').forEach(function (b) { render(b, shirts); });
  }

  function syncCheckoutTotal() {
    var ct = document.querySelector('[data-pholoh-checkout-total]');
    var sub = document.querySelector('[data-subtotal]');
    if (ct && sub) ct.innerHTML = sub.innerHTML;
  }
  function syncCount(count) {
    if (typeof count !== 'number') return;
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = '(' + count + ')'; });
  }

  function refresh() {
    syncCheckoutTotal();
    var hasBar = document.querySelector('[data-pholoh-gwp]');
    var hasCount = document.querySelector('[data-cart-count]');
    if (!hasBar && !hasCount) return;
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        renderAll(countShirts(cart));
        syncCount(cart.item_count);
      })
      .catch(function () {});
  }

  function init() {
    var bars = document.querySelectorAll('[data-pholoh-gwp]');
    bars.forEach(function (b) { render(b, parseInt(b.dataset.shirts || '0', 10)); }); // initial (Liquid count)
    syncCheckoutTotal();
    if (!bars.length && !document.querySelector('[data-pholoh-checkout-total]') && !document.querySelector('[data-cart-count]')) return;
    document.addEventListener('ajaxProduct:added', refresh);
    var sub = document.querySelector('[data-subtotal]');
    if (sub) new MutationObserver(refresh).observe(sub, { childList: true, characterData: true, subtree: true });
  }

  if (document.readyState !== 'loading') init();
  else document.addEventListener('DOMContentLoaded', init);
})();
